var SummaryPageModalEnum;
(function (SummaryPageModalEnum) {
    SummaryPageModalEnum["confirmationCard"] = "confirmationCard";
    SummaryPageModalEnum["ecoFeeCard"] = "ecoFeeCard";
    SummaryPageModalEnum["energyFicheCard"] = "energyFicheCard";
    SummaryPageModalEnum["energyLabelCard"] = "energyLabelCard";
    SummaryPageModalEnum["unavailableProductCard"] = "unavailableProductCard";
    SummaryPageModalEnum["storeSelectorCard"] = "storeSelectorCard";
    SummaryPageModalEnum["shareDesignCard"] = "shareDesignCard";
    SummaryPageModalEnum["buyInStore"] = "buyInStore";
    SummaryPageModalEnum["financialServicesCard"] = "financialServicesCard";
    SummaryPageModalEnum["sortListCard"] = "sortListCard";
    SummaryPageModalEnum["saveDesignToProfileCard"] = "saveDesignToProfileCard";
    SummaryPageModalEnum["zipIn"] = "zipIn";
})(SummaryPageModalEnum || (SummaryPageModalEnum = {}));
export default SummaryPageModalEnum;
//# sourceMappingURL=SummaryPageModalEnum.js.map